import { useEffect, useRef, useState } from "react";
import { NavLink, matchPath, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Phone/tablet dashboard navigation (the sidebar is hidden under 992px): one button showing the
// current section that opens a grid of all sections, so nothing scrolls sideways.
export default function DashMobileNav({ items }) {
    const { t } = useTranslation();
    const location = useLocation();
    const chatlist = useSelector((state) => state.chatListReducer);
    const unread = chatlist?.data?.reduce?.((sum, c) => sum + (Number(c?.unread_count) || 0), 0) || 0;
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const current = items.find((item) => matchPath({ path: item.to, end: !!item.end }, location.pathname))
        || items.find((item) => location.pathname.startsWith(item.to))
        || items[0];

    useEffect(() => { setOpen(false); }, [location.pathname]);

    useEffect(() => {
        if (!open) return undefined;
        const onDown = (e) => rootRef.current && !rootRef.current.contains(e.target) && setOpen(false);
        const onKey = (e) => e.key === "Escape" && setOpen(false);
        document.addEventListener("mousedown", onDown);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDown);
            document.removeEventListener("keydown", onKey);
        };
    }, [open]);

    return (
        <nav className="dash-switcher d-lg-none" ref={rootRef} aria-label={t("dashMobileNav.dashboard_navigation")}>
            <button type="button" className="dash-switcher-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
                <span className="dash-switcher-icon"><i className={current?.icon} /></span>
                <span className="dash-switcher-text">
                    <small>{t("dashMobileNav.section")}</small>
                    <strong>{current?.label}</strong>
                </span>
                {unread > 0 && current?.badge !== "unread" && <span className="dash-switcher-dot" aria-label={t("dashMobileNav.unread_messages")} />}
                <i className={`fa-light fa-chevron-down dash-switcher-chevron ${open ? "is-open" : ""}`} />
            </button>

            {open &&
                <div className="dash-switcher-panel">
                    {items.map((item) => (
                        <NavLink key={item.to} to={item.to} end={item.end} className="dash-switcher-link">
                            <i className={item.icon} />
                            <span>{item.label}</span>
                            {item.badge === "unread" && unread > 0 && <span className="dash-mobile-badge">{unread}</span>}
                        </NavLink>
                    ))}
                </div>
            }
        </nav>
    );
}
